import classNames from 'classnames';
import styles from './booking-status-badge.module.scss';
import { FC } from 'react';

export enum BookingStatusBadgeType {
  BOOKED = 'BOOKED',
  RUNNING = 'RUNNING',
  RETURNED = 'RETURNED',
  CANCELLED = 'CANCELLED',
}

export type BookingStatusBadge = {
  status: BookingStatusBadgeType;
  translations: {
    booked: string;
    running: string;
    returned: string;
    cancelled: string;
  }
}

export const BookingStatusBadge: FC<BookingStatusBadge> = ({status, translations}) => {
  let name = status.toString();

  switch (status) {
    case BookingStatusBadgeType.BOOKED:
      name = translations.booked;
      break;
    case BookingStatusBadgeType.RUNNING:
      name = translations.running;
      break;
    case BookingStatusBadgeType.RETURNED:
      name = translations.returned;
      break;
    case BookingStatusBadgeType.CANCELLED:
      name = translations.cancelled;
      break;
  }

  return (
    <div className={classNames({
      [styles.bookingStatusBadge]: true,
      [styles.booked]: status === BookingStatusBadgeType.BOOKED,
      [styles.running]: status === BookingStatusBadgeType.RUNNING,
      [styles.returned]: status === BookingStatusBadgeType.RETURNED,
      [styles.cancelled]: status === BookingStatusBadgeType.CANCELLED,
    })}>{name}</div>
  )
}
